import React from 'react';
import PropTypes from 'prop-types';

import './Loader.scss';

interface SpinnerProps {
  size: string;
}


function Spinner({ size }: SpinnerProps) {
  return (
    <div className={`common_spinner ${size}`} />
  );
}

Spinner.defaultProps = {
  size: 'small',
};

Spinner.propTypes = {
  size: PropTypes.string,
};

export default Spinner;
